import React from 'react';
import Skeleton from "react-loading-skeleton";
import {useLocation} from "react-router-dom";

const DashboardTableSkeleton = ({location}) => {
    return (
        <tr>
            {location !== "/dashboard" && (
                <>
                    <td><Skeleton height={16} width={100}/></td>
                    <td><Skeleton height={16} width={100}/></td>
                    <td><Skeleton height={16} width={100}/></td>
                    <td><Skeleton height={16} width={100}/></td>
                    <td>
                        <div className="download-icon"><Skeleton height={20} width={20}/></div>
                    </td>
                </>
            )}

            {location === "/dashboard" && (
                <>
                    <td><Skeleton height={16} width={20}/></td>
                    <td><Skeleton height={16} width={100}/></td>
                    <td><Skeleton height={16} width={80}/></td>
                    <td><Skeleton height={16} width={100}/></td>
                    <td><Skeleton height={16} width={100}/></td>
                    <td><Skeleton height={16} width={50}/></td>
                    <td><Skeleton height={16} width={30}/></td>
                    <td className="d-flex align-content-center justify-content-center"><Skeleton height={16} width={100}/></td>
                    <td className="table-action"><Skeleton height={16} width={30}/></td>
                </>
            )}
        </tr>
    );
};

const TableSkeleton = () => {
    const location = useLocation();
    let list = [];
    for (let i = 1; i <= 4; i++) {
        list.push(<DashboardTableSkeleton location={location.pathname} key={i}/>)
    }
    return list;
}

export default TableSkeleton;
